<template>
    <td-dialog :title="$t(title)" :visible.sync="dialogSortVisible" :before-close="sortDialogClose" :close-on-click-modal="false" :close-on-press-escape="false" width="800px" append-to-body>
        <el-form :inline="true" :model="fromDevice" ref="fromDevice" class="demo-form-inline" :rules="rules" @submit.native.prevent>
            <el-row>
                <el-form-item :label="$t('common.DEVICE_NAME')" prop="sName">
                    <td-input v-model="fromDevice.sName"></td-input>
                </el-form-item>
                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :loading="loading" @click="btnClickQuery">{{ $t('common.QUERY') }}</td-button>
                </el-form-item>
            </el-row>
            <el-row style="margin-top:10px;margin-bottom:-10px;">
                <el-form-item>
                    <td-button @click="batchMoveToTop">{{ $t('pgCommon.BATCH_MOVE_TOP') }}</td-button>
                </el-form-item>
                <el-form-item>
                    <td-button @click="batchRemoveTop">{{ $t('pgCommon.BATCH_REMOVE_TOP') }}</td-button>
                </el-form-item>
            </el-row>
        </el-form>
        <td-table
            :columns="columns"
            :dataSource="tableData"
            :pageSize="pageSize"
            :currentPage="currentPage"
            :total="total"
            :hasLoading="loading"
            :hasMutiSelect="true"
            :stripe="false"
            @row-click="rowClick"
            @handleSizeChange="handleSizeChange"
            @currentChange="currentChange"
            @selection-change="selectionChange"
            height="400px"
            rowKey="sId"
            ref="deviceTab"
        ></td-table>
        <span slot="footer"></span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: {
        title: {
            type: [String, String]
        },
        dialogSortVisible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 设备类型
        iDeviceTypes: {
            type: Array,
            default: function() {
                return null;
            }
        },
        // 所属组织
        sOrgId: {
            type: String,
            default: function() {
                return null;
            }
        }
    },
    mounted() {
        if (this.$util.isEmpty(this.fromDevice.sName)) {
            this.isQueryByName = true;
        } else {
            this.isQueryByName = false;
        }
        this.btnQuery();
    },
    data() {
        return {
            fromDevice: {
                sName: ''
            },
            tableData: [],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数,
            hasLoading: false,
            loading: false,
            isQueryByName: false,
            selectRow: null,
            selfSelect: [],
            //表头数据
            columns: [
                {
                    prop: 'sName',
                    label: 'pgCommon.NAME'
                },
                {
                    prop: 'sOrgName',
                    label: 'pgCommon.USERDEPT',
                    align: 'center'
                },
                {
                    prop: '',
                    label: 'pgCommon.OPERATE',
                    tableWidth: '250',
                    align: 'center',
                    render: (createElement, params) => {
                        // 上移
                        let b1 = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickMoveUp(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.MOVE_UP')
                        );
                        // 下移
                        let b2 = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsDel, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickMoveDown(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.MOVE_DOWN')
                        );
                        // 置顶
                        let b3 = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickMoveTop(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.MOVE_TOP')
                        );
                        // 取消
                        let b4 = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickCancelTop(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.CANCEL')
                        );
                        let list = [];
                        // 如果是按名称查询，则隐藏上移下移
                        if (this.isQueryByName) {
                            if (params.row.iOrder < 10000) {
                                list = [b1, b2, b3, b4];
                            } else {
                                list = [b3];
                            }
                        } else {
                            if (params.row.iOrder < 10000) {
                                list = [b3, b4];
                            } else {
                                list = [b3];
                            }
                        }
                        return createElement('div', list);
                    }
                }
            ],
            // 对表单进行数据验证
            rules: {
                sName: [{ pattern: window.pangu.regex.DEV_CAPTION_RULE, message: this.$t('pgRegex.ERROR_CAPTION_ILLEGAL') }]
            }
        };
    },
    methods: {
        // 点击某一行
        rowClick(row, event, column) {
            this.selectRow = row;
        },

        // 查询
        btnClickQuery() {
            this.loading = true;
            if (this.$util.isEmpty(this.fromDevice.sName)) {
                this.isQueryByName = true;
            } else {
                this.isQueryByName = false;
            }
            this.btnQuery();
        },

        // 获取查询参数
        getParam() {
            let param = {
                sName: this.fromDevice.sName,
                isPage: true,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                iDeviceTypes: this.iDeviceTypes,
                sOrgId: this.sOrgId
            };
            return param;
        },

        // 查询数据
        btnQuery(param) {
            if (this.$util.isEmpty(param)) {
                param = this.getParam();
            }
            api.queryDeviceContainOrder(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/queryDeviceContainOrder', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/device/queryDeviceContainOrder', response.data.statusMessage);
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                if (this.selectRow != null) {
                    this.$refs.deviceTab.setCurrentRow(this.selectRow);
                }
            });
        },

        // 上移
        onClickMoveUp(row) {
            // 上一条数据的序号
            let perviousIndex = '';
            if (this.tableData != null && this.tableData.length > 0) {
                for (let i = 0; i < this.tableData.length; i++) {
                    if (row.sId === this.tableData[i].sId) {
                        perviousIndex = i - 1;
                        break;
                    }
                }
            }
            let perviousData = this.tableData[perviousIndex];
            if (!this.$util.isEmpty(perviousData)) {
                let param = {
                    sOrgId: this.sOrgId,
                    sDeviceId: row.sId,
                    latterId: perviousData.sId
                };
                this.moveUpOrDown(param);
            } else {
                let param = {
                    sOrgId: this.sOrgId,
                    sDeviceId: row.sId,
                    queryType: 1
                };
                api.queryPerviousOrLatter(JSON.stringify(param), response => {
                    this.loading = false;
                    if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                        this.$log.error('/device/queryPerviousOrLatter', response);
                        this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                        return;
                    }
                    if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        this.$log.error('/device/queryPerviousOrLatter', response.data.statusMessage);
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        return;
                    }
                    if (this.$util.isEmpty(response.data.content)) {
                        this.$message({ showClose: true, message: this.$t('pgMessage.TOP_NODE_CANNT_MOVEUP'), type: 'warning' });
                        return;
                    }
                    this.currentPage--;
                    let perviousItem = response.data.content;
                    let param = {
                        sOrgId: this.sOrgId,
                        sDeviceId: row.sId,
                        previousId: perviousItem.sDeviceId
                    };
                    this.moveUpOrDown(param);
                });
            }
        },

        // 下移
        onClickMoveDown(row) {
            let latterIndex = null;
            // 取下一条数据
            if (this.tableData != null && this.tableData.length > 0) {
                for (let i = 0; i < this.tableData.length; i++) {
                    if (row.sId === this.tableData[i].sId) {
                        latterIndex = i + 1;
                        break;
                    }
                }
            }
            let latterData = this.tableData[latterIndex];
            if (!this.$util.isEmpty(latterData)) {
                if (latterData.iOrder == 10000) {
                    this.$message({ showClose: true, message: this.$t('pgMessage.ONLY_MOVE_TOP_CAN_OPERATE_CANNT_MOVE_DOWN'), type: 'warning' });
                    return;
                } else if (!this.$util.isEmpty(latterData) && latterData.iOrder < 10000) {
                    let param = {
                        sOrgId: this.sOrgId,
                        sDeviceId: row.sId,
                        latterId: latterData.sId
                    };
                    this.moveUpOrDown(param);
                }
            } else {
                let param = {
                    sOrgId: this.sOrgId,
                    sDeviceId: row.sId,
                    queryType: 2
                };
                api.queryPerviousOrLatter(JSON.stringify(param), response => {
                    this.loading = false;
                    if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                        this.$log.error('/device/queryPerviousOrLatter', response);
                        this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                        return;
                    }
                    if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        this.$log.error('/device/queryPerviousOrLatter', response.data.statusMessage);
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        return;
                    }
                    if (this.$util.isEmpty(response.data.content)) {
                        this.$message({ showClose: true, message: this.$t('pgMessage.LAST_ONE_CANNT_MOVE_DOWN'), type: 'warning' });
                        return;
                    }
                    let latterItem = response.data.content;
                    if (latterItem.iOrder == 10000) {
                        this.$message({ showClose: true, message: this.$t('pgMessage.ONLY_MOVE_TOP_CAN_OPERATE_CANNT_MOVE_DOWN'), type: 'warning' });
                        return;
                    } else if (!this.$util.isEmpty(latterItem) && latterItem.iOrder < 10000) {
                        this.currentPage++;
                        let param = {
                            sOrgId: this.sOrgId,
                            sDeviceId: row.sId,
                            latterId: latterItem.sDeviceId
                        };
                        this.moveUpOrDown(param);
                    }
                });
            }
        },

        // 上移或者下移
        moveUpOrDown(param) {
            api.moveUpOrDown(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/moveUpOrDown', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/device/moveUpOrDown', response.data.statusMessage);
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.btnQuery();
            });
        },

        // 置顶
        onClickMoveTop(row) {
            let param = {
                sDeviceId: row.sId,
                iDeviceTypes: this.iDeviceTypes,
                sOrgId: this.sOrgId
            };
            api.moveToTop(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/onClickMoveTop', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/device/onClickMoveTop', response.data.statusMessage);
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.btnQuery();
            });
        },

        // 批量置顶
        batchMoveToTop() {
            let sDeviceIds = this.getSelectedParam();
            if (sDeviceIds.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_CHOOSE_DEVICE'), type: 'warning' });
                return;
            }
            let param = {
                sDeviceIds: sDeviceIds,
                iDeviceTypes: this.iDeviceTypes,
                sOrgId: this.sOrgId
            };
            api.batchMoveToTop(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/batchMoveToTop', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/device/batchMoveToTop', response.data.statusMessage);
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.btnQuery();
            });
        },

        selectionChange(selection) {
            this.selfSelect = selection;
        },

        getSelectedParam() {
            let row = this.selfSelect;
            let sDeviceIds = [];
            row.forEach(val => {
                sDeviceIds.push(val.sId);
            });
            return sDeviceIds;
        },

        // 取消置顶
        onClickCancelTop(row) {
            let param = {
                sDeviceId: row.sId,
                sOrgId: this.sOrgId
            };
            api.removeFromTop(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/removeFromTop', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/device/removeFromTop', response.data.statusMessage);
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.btnQuery();
            });
        },

        // 批量取消置顶
        batchRemoveTop() {
            let sDeviceIds = this.getSelectedParam();
            if (sDeviceIds.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_CHOOSE_DEVICE'), type: 'warning' });
                return;
            }
            let param = {
                sDeviceIds: sDeviceIds,
                sOrgId: this.sOrgId
            };
            api.removeFromTop(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/removeFromTop', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/device/removeFromTop', response.data.statusMessage);
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.btnQuery();
            });
        },

        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            if (this.$util.isEmpty(this.fromDevice.sName)) {
                this.isQueryByName = true;
            } else {
                this.isQueryByName = false;
            }
            this.btnQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            if (this.$util.isEmpty(this.fromDevice.sName)) {
                this.isQueryByName = true;
            } else {
                this.isQueryByName = false;
            }
            this.btnQuery();
        },

        // 关闭窗口之前需要调用的方法
        sortDialogClose() {
            this.$emit('sortDialogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
</style>
